
@switch (mode) {
  @case (LabelMode.DEFAULT) {
    <ng-container
      [ngTemplateOutlet]="default"
    ></ng-container>
  }
  @case (LabelMode.INLINE) {
    <ng-container
      [ngTemplateOutlet]="inline"
    ></ng-container>
  }
  @case (LabelMode.NO_LABEL) {
    <ng-container
      [ngTemplateOutlet]="input"
    ></ng-container>
  }
}

<ng-template #input>
  <ngb-timepicker
    [formControl]="form"
    [spinners]="spinners"
    class="{{ modeClass }} "
    [ngClass]="{ 'is-invalid': isError }"
  ></ngb-timepicker>
  <!-- <ngb-timepicker [name]="name" [formControl]="form" [spinners]="spinners" [class]="modeClass" [ngClass]="{ 'is-invalid': isError }"></ngb-timepicker> -->
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="{ 'is-invalid': isError }"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
      >
      <ng-container [ngTemplateOutlet]="input"></ng-container>
      <ng-container [ngTemplateOutlet]="error"></ng-container>
    </div>
  </ng-template>

  <ng-template #inline>
    <div class="form-group form-group-inline" [ngClass]="classes">
      <label
        [for]="name"
        class="col-form-label fw-bold fs-6 py-2"
        [ngClass]="{ 'is-invalid': isError }"
        [ngClass]="required ? 'required' : ''"
        >{{ label | translate }}</label
        >
        <ng-container [ngTemplateOutlet]="input"></ng-container>
      </div>
    </ng-template>

    <ng-template #error>
      @if (isError) {
        <span class="error">{{ errorMessage | translate }}</span>
      }
    </ng-template>
